export const ceilPrice = (value: string | number): string => {
  const num = Number(value)
  if (isNaN(num)) return '0'
  return String(Math.ceil(num))
}
